import { useCallback, useState } from 'react';
import { requestWhatsappHandoff } from '../api/botApi';

/**
 * Drives the "Continue on WhatsApp" button.
 *
 * Asks the BE for a tokenized wa.me URL, then opens it in a new tab so the
 * native WhatsApp install (mobile) or WhatsApp Web (desktop) handles the
 * prefilled message. The session.handed_off event on the socket will close
 * the panel once SmartSend forwards the user's send back to us.
 */
export function useWhatsappHandoff() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handoff = useCallback(async (sessionId: string) => {
    setBusy(true);
    setError(null);
    try {
      const { wa_url } = await requestWhatsappHandoff(sessionId);
      // window.open with _blank — falls back to same-tab navigation when popups
      // are blocked. Both surface the prefilled wa.me link the same way.
      const opened = window.open(wa_url, '_blank', 'noopener,noreferrer');
      if (!opened) window.location.href = wa_url;
    } catch (e: any) {
      const msg = e?.response?.data?.message ?? e?.message ?? 'handoff_failed';
      setError(msg);
    } finally {
      setBusy(false);
    }
  }, []);

  return { handoff, busy, error };
}
